"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractBillingMeta = void 0;
var lodash_1 = require("lodash");
var AbstractBillingMeta = /** @class */function () {
  function AbstractBillingMeta() {}
  AbstractBillingMeta.createInstance = function (values) {
    var instance = new this();
    instance.applyValues(values);
    return instance;
  };
  AbstractBillingMeta.prototype.toMetadata = function () {
    return (0, lodash_1.pick)(this, this.getClassProperties());
  };
  AbstractBillingMeta.prototype.toString = function () {
    return "".concat(this.constructor.name, ".createInstance(").concat(JSON.stringify(this), ")");
  };
  AbstractBillingMeta.prototype.applyValues = function (values) {
    var instance = this;
    (0, lodash_1.assign)(instance, (0, lodash_1.pick)(values, this.getClassProperties()));
  };
  AbstractBillingMeta.prototype.getClassProperties = function () {
    return ['model', 'tenant'];
  };
  return AbstractBillingMeta;
}();
exports.AbstractBillingMeta = AbstractBillingMeta;
